import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { withStyles, Grid, ListItem, ListItemIcon, Typography } from "@material-ui/core";
import axios from 'axios';
import { currentHttpOptions } from '../common/utilities/utilitiesFunctions';
import WPSettings from '../WorkplanManager/Admin';
import { faHistory, faBallotCheck, faCalendarEdit, faCog } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import AppDrawer from '../common/components/UI/AppDrawer/AppDrawer';
import { app } from '../WorkplanManager/styles/workplanStyles';

const emptyPublicConfigs = {
    appEnvironment: '',
    isMultiLanguage: true,
    version: '',
};

// Reuse existing styles from workplanStyles.js with minimal overrides
const styles = theme => ({
    ...app(theme),
    root: {
        width: '97%',
        display: 'flex',
        marginBlockStart: "1%",
        position: 'relative',
    },
    icon: {
        fontSize: '20px',
        color: '#000000',
        minWidth: 32,
    },
        backdrop: {
        width: '100vw',
        height: '100vh',
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1
    },
});

const appIcon = {
    callList: ['fal', 'phone'],
    quotaManagement: ['fal', 'chart-pie'],
    requestCalendar: ['fal', 'calendar'],
    hcScheduleReport: ['fal', 'clock'],
    dailyShiftBidding: faBallotCheck,
    shiftBidding: ['fal', 'calendar-alt'],
    vacationBidding: ['fal', 'plane-departure'],
    workplanManager: faCalendarEdit,
    shiftHistory: faHistory
}

// Admin view configuration
const adminViews = [
    {
        key: 'Dashboard',
        icon: faCalendarEdit,
        translationKey: 'workplanManager:settings.appNameAdminDashboard'
    },
    {
        key: 'GlobalSetup',
        icon: faCog,
        translationKey: 'workplanManager:settings.appNameGlobalSetup'
    }
];

class AdminSettings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            applicationSelected: "workplanManager",
            viewSelected: "Dashboard",
            applications: [
                { "name": "workplanManager", "api": "dimensions", "status": "active", "env_sso": "active", "sso": true, "env": ["admin"], "token": false }
            ],
            extended: false
        }
        document.title = "Workplan Manager (Admin)";
        this.init();
    }

    init = async () => {

        const { data: publicConfigs } = await axios.get(process.env.REACT_APP_DOTNET_URL + '/api/v1/public/configs', currentHttpOptions());
        Object.keys(emptyPublicConfigs).forEach((key) => {
            sessionStorage.setItem(key, publicConfigs[key]);
        });
    }

    handleOnClickApplication = (app) => {
        this.setState({
            applicationSelected: app,
            viewSelected: "Dashboard",
            extended: false
        });
        localStorage.setItem('adminAppSelected', app);
    }

    handleOnClickView = (view) => {
        this.setState({
            viewSelected: view,
            extended: false
        });
    }

    handleSideMenu = (event, extend) => {
        event.stopPropagation()
        this.setState({ extended: extend })
    }

    render() {
        const { classes, refreshAdmin, t } = this.props;
        const { extended, applicationSelected, viewSelected, applications } = this.state;

        const appComponent = {
            workplanManager: <WPSettings refreshAdmin={refreshAdmin} initialView={viewSelected} />
        }

        let app = appComponent[applicationSelected];

        // Create drawer menu items using data-driven approach
        const drawerItems = adminViews.map((view) => (
            <ListItem
                key={view.key}
                button
                className={classes.listItemNoHover}
                classes={{ selected: classes.selected }}
                onClick={() => this.handleOnClickView(view.key)}
                selected={viewSelected === view.key}
            >
                <ListItemIcon
                    className={clsx(classes.icon, {
                        [classes.selected]: viewSelected === view.key
                    })}
                >
                    <FontAwesomeIcon icon={view.icon} />
                </ListItemIcon>
                <Typography
                    className={clsx(classes.navElement, {
                        [classes.selected]: viewSelected === view.key
                    })}
                >
                    {t(view.translationKey)}
                </Typography>
            </ListItem>
        ));

        return <React.Fragment>
            <Grid item xs={12} className={classes.content}>
                <div className={classes.contentWrapper}>
                    <AppDrawer
                        applicationSelected={applicationSelected}
                        applications={applications}
                        appIcon={appIcon}
                        extended={extended}
                        handleSideMenu={this.handleSideMenu}
                        handleOnClickApplication={this.handleOnClickApplication}
                        renderedDrawerContent={drawerItems}
                        t={this.props.t}
                    />
                    <div className='workPlan-app-container'>{app}</div>
                </div>
            </Grid>
        </React.Fragment>
    }
}

export default translate(['common', 'hcScheduleReport', 'workplanManager', 'quotaManagement', 'requestCalendar', 'dailyShiftBidding', 'vacationBidding', 'shiftBidding', 'shiftHistory'])(withStyles(styles)(AdminSettings));